import golinksLogoActive from '../../../../html/d/images/logos/golinks/golinks_logo_2023.svg';
import goprofilesLogoActive from '../../../../html/d/images/logos/goprofiles/goprofiles_logo_2023.svg';
import gosearchLogoActive from '../../../../html/d/images/logos/gosearch/gosearch_logo_2023.svg';
// import gogoalsLogoActive from '../../../../html/d/images/logos/gogoals/gogoals_logo_2023.svg';

const currentProduct = 'gosearch'; // update to current
const isCurrentProductGolinks = currentProduct === 'golinks';
const isCurrentProductGoprofiles = currentProduct === 'goprofiles';
const isCurrentProductGoSearch = currentProduct === 'gosearch';
// const isCurrentProductGoGoals = currentProduct === 'gogoals';

// eslint-disable-next-line import/prefer-default-export
export const products = [
  {
    name: 'GoLinks',
    url: `https://golinks.io/landing.php?ref=${currentProduct}`,
    logo: golinksLogoActive,
    active: isCurrentProductGolinks,
    information: {
      img: 'https://www.gosearch.ai/d/images/external_pages/external_app_switcher/golinks_app_switcher.webp',
      imgContainerClasses: 'p-3 bg-light-teal',
      header: 'Memorable short links',
      description: 'Get to any resource instantly using memorable go links shared by your entire org.',
      features: [
        '⚡ Instant resource access',
        '🧠️ Intuitive knowledge sharing',
        '💡 Information discovery',
        '✨ AI-powered suggestions',
      ],
    },
  },
  {
    name: 'GoSearch',
    url: `https://gosearch.ai/landing?ref=${currentProduct}`,
    logo: gosearchLogoActive,
    active: isCurrentProductGoSearch,
    information: {
      img: 'https://www.gosearch.ai/d/images/external_pages/external_app_switcher/gosearch_app_switcher.webp',
      imgContainerClasses: 'px-3 pt-3 bg-light-skyblue',
      header: 'Enterprise search',
      description: 'Search across all your content hubs from one search bar—results powered by generative AI.',
      features: [
        '🔍️ Search across all work apps',
        '✨ AI-powered results',
        '🤖 AI conversational chat',
        '⚡️ 100+ data connectors',
      ],
    },
  },
  {
    name: 'GoProfiles',
    url: `https://goprofiles.io/landing?ref=${currentProduct}`,
    logo: goprofilesLogoActive,
    active: isCurrentProductGoprofiles,
    information: {
      img: 'https://www.gosearch.ai/d/images/external_pages/external_app_switcher/goprofiles_app_switcher.webp',
      imgContainerClasses: 'px-3 pt-3 bg-light-purple',
      header: 'People knowledge',
      description:
        'Find and discover information about the people of your org. Give recognition and celebrate achievements.',
      features: ['🙋‍♀️️ Employee profiles', '👍️ Peer recognition', '📈️ Employee engagement', '✨ AI-powered search'],
    },
  },
  // {
  //   url: `https://gogoals.io/landing?ref=${currentProduct}`,
  //   logo: gogoalsLogoActive,
  //   active: isCurrentProductGoGoals,
  //   width: '76px',
  // },
];
